<template>
    <div class="wallet">
        <div class="placeholder"></div>
        <div class="wallet-content wallet-warp">
            <div class="wallet-card">
                <div class="wallet-card-header">
                    <div>
                        <div class="value">
                            <span>{{totalwallet}}</span>
                            <i></i>
                        </div>
                        <div class="label">{{$t('wallet.title')}}(USDT)</div>
                    </div>
                    <div class="wallet-card-header-r" @click="go('/record')" >
                        {{$t('wallet.record')}}
                        <img src="../../assets/img/wallet/arrow-r.png" alt="">
                    </div>
                </div>
                <div class="wallet-card-c">
                    <div>
                        <div class="value">
                            <span>+{{dayMining}}</span><i></i>
                        </div>
                        <div class="label">{{$t('wallet.static')}} (USDT)</div>
                    </div>
                    <div>
                        <div class="value">
                            <span>+{{dayDynamic}}</span><i></i>
                        </div>
                        <div class="label">{{$t('wallet.dynamic')}} (USDT)</div>
                    </div>
                </div>

                <div class="wallet-card-b">
                    <div @click="recharge()">{{$t('wallet.topup')}}</div>
                    <div @click="go('/withdraw')" >{{$t('wallet.withdraw')}}</div>
                </div>
            </div>
            <div class="wallet-revenue">
                <div>
                    <div class="value">
                        <span>{{totalMining}}</span> <i></i>
                    </div>
                    <div class="label">
                        {{$t('wallet.totalRevenue')}}(USDT)
                    </div>
                </div>
                <div>
                    <div class="value">
                        <span>{{totalDynamic}}</span> <i></i>
                    </div>
                    <div class="label">
                        {{$t('wallet.totalReward')}}(USDT)
                    </div>
                </div>
            </div>

            <div class="wallet-list">
                <div class="wallet-list-item">
                    <div> <img src="../../assets/img/wallet/icon.png" alt="">
                        <span>{{$t('wallet.fund1')}}</span>
                    </div>
                    <span class="num">{{wallet1}}</span>
                </div>
                <div class="wallet-list-line"></div>
                <div class="wallet-list-item">
                    <div> <img src="../../assets/img/wallet/icon.png" alt="">
                        <span>{{$t('wallet.fund2')}}</span>
                    </div>
                    <span class="num">{{wallet2}}</span>
                </div>
                <div class="wallet-list-line"></div>
                <div class="wallet-list-item">
                    <div> <img src="../../assets/img/wallet/icon.png" alt="">
                        <span>{{$t('wallet.fund3')}}</span>
                    </div>
                    <span class="num">{{wallet3}}</span>
                </div>
                
            </div>
        </div>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import contractaa from '../contract/index.js'

export default {
    name: "wallet",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "1",
            show: false,
            wallet1: 0,
            wallet2: 0,
            wallet3: 0,
            totalwallet:0,
            dayMining:0,
            totalMining:0,
            dayDynamic:0,
            totalDynamic:0

        };
    },
    computed: {},
    
    methods: {
        
        go(path) {
            this.$router.push(path)
        },
        getInfo(){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=wallet','token='+ _token).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        let _vlist = response.data.Message.split('|')
                        that.wallet1 = _vlist[0]
                        that.wallet2 = _vlist[1]
                        that.wallet3 = _vlist[2]
                        that.totalwallet = Number(that.wallet1)+Number(that.wallet2)+Number(that.wallet3)
                        that.dayMining = _vlist[3]
                        that.dayDynamic = _vlist[4]
                        that.totalMining = _vlist[5]
                        that.totalDynamic = _vlist[6]
                    }

                }
            })
        },
        recharge(){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=addre','token='+ _token).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        let _vlist = response.data.Message
                        //console.log(_vlist)
                        window.location.href=_vlist;
                    }

                }
            })
        }
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.wallet {
    position: relative;

    .placeholder {
        // height: 50px;
    }

    .wallet-warp {
        padding: 0 20px;
    }

    &-content {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
    }

    &-card {
        min-height: 217px;
        background: url('../../assets/img/wallet/card-bg.png') no-repeat;
        background-size: 100% 100%;
        padding: 15px 15px 20px;

        &-header {
            padding-bottom: 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .value {
                font-size: 22px;
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 26px;

                i {
                    font-size: 14px;
                    font-style: normal;
                }
            }

            .label {
                margin-top: 4px;
                font-size: 12px;
                color: #838383;
                line-height: 17px;
                font-weight: 400;
            }

            &-r {
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #838383;
                line-height: 12px;

                img {
                    width: 12px;
                    height: 12px;
                    margin-left: 4px;
                }
            }
        }

        &-c {
            display: flex;
            height: 60px;
            padding-top: 4px;

            >div {
                flex: 1;

                .value {
                    font-weight: bold;
                    font-family: DINAlternate, DINAlternate;
                    color: #27BB3D;
                    font-size: 18px;
                    line-height: 21px;

                    i {
                        font-size: 12px;
                        font-style: normal;
                    }
                }

                .label {
                    margin-top: 4px;
                    color: #838383;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 17px;


                }
            }
        }

        &-b {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;

            >div {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            >div:nth-child(1) {
                height: 50px;
                background: #FFFFFF;
                width: 146px;
                border-radius: 25px;
                color: #000000;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
            }

            >div:nth-child(2) {
                height: 50px;
                width: 146px;
                border-radius: 25px;
                color: #fff;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                background: url('../../assets/img/wallet/btn-bg.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .wallet-revenue {
        display: flex;
        margin-top: 10px;
        justify-content: space-between;
        background: #1B1C1E;
        border-radius: 16px;
        >div {
            min-height: 70px;
            width: 167px;
            padding: 14px 15px;

            .label {
                font-size: 12px;
                color: #838383;
                line-height: 17px;
                margin-top: 5px;
            }

            .value {
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 21px;

                i {
                    font-size: 14px;
                    font-style: normal;
                }
            }
        }
    }

    .wallet-list {
        margin-top: 10px;
        padding: 0 15px;
        background: #1B1C1E;
        border-radius: 16px;
        &-item {
            padding: 15px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            >div {
                display: flex;
                align-items: center;

                img {
                    width: 30px;
                    height: 30px;
                }

                span {
                    margin-left: 10px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 20px;
                }
            }

            .num {
                font-size: 18px;
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 21px;
            }
        }
        &-line{
            width: 100%;
            height: 1px;
            opacity: 0.1;
            background: rgba(151, 151, 151, 1);
        }
    }


}
</style>
<style lang="less"></style>